// Content snippets module
// Processes icon blocks (question-mark, exclamation-mark, search-mark, info-mark) and grid layouts

import { processTooltipReferences } from './footnotes.js';

const ICON_SVGS = {
  'question-mark': `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 24C4.5 13.23 13.23 4.5 24 4.5C34.77 4.5 43.5 13.23 43.5 24C43.5 34.77 34.77 43.5 24 43.5C13.23 43.5 4.5 34.77 4.5 24ZM27.256 16.166C25.476 14.612 22.524 14.612 20.746 16.166C20.4466 16.428 20.0553 16.5604 19.6583 16.5339C19.2613 16.5075 18.891 16.3244 18.629 16.025C18.367 15.7256 18.2346 15.3343 18.2611 14.9373C18.2875 14.5403 18.4706 14.17 18.77 13.908C21.678 11.364 26.322 11.364 29.23 13.908C32.256 16.556 32.256 20.944 29.23 23.592C28.7239 24.0333 28.1609 24.4046 27.556 24.696C26.204 25.352 25.5 26.244 25.5 27V28.5C25.5 28.8978 25.342 29.2794 25.0607 29.5607C24.7794 29.842 24.3978 30 24 30C23.6022 30 23.2206 29.842 22.9393 29.5607C22.658 29.2794 22.5 28.8978 22.5 28.5V27C22.5 24.442 24.62 22.786 26.25 21.996C26.614 21.82 26.952 21.598 27.256 21.334C28.916 19.88 28.916 17.62 27.256 16.166ZM24 36C24.3978 36 24.7794 35.842 25.0607 35.5607C25.342 35.2794 25.5 34.8978 25.5 34.5C25.5 34.1022 25.342 33.7206 25.0607 33.4393C24.7794 33.158 24.3978 33 24 33C23.6022 33 23.2206 33.158 22.9393 33.4393C22.658 33.7206 22.5 34.1022 22.5 34.5C22.5 34.8978 22.658 35.2794 22.9393 35.5607C23.2206 35.842 23.6022 36 24 36Z" fill="var(--color-accent)"/>
</svg>`,
  'exclamation-mark': `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 24C4.5 13.23 13.23 4.5 24 4.5C34.77 4.5 43.5 13.23 43.5 24C43.5 34.77 34.77 43.5 24 43.5C13.23 43.5 4.5 34.77 4.5 24ZM24 16.5C24.3978 16.5 24.7794 16.658 25.0607 16.9393C25.342 17.2206 25.5 17.6022 25.5 18V25.5C25.5 25.8978 25.342 26.2794 25.0607 26.5607C24.7794 26.842 24.3978 27 24 27C23.6022 27 23.2206 26.842 22.9393 26.5607C22.658 26.2794 22.5 25.8978 22.5 25.5V18C22.5 17.6022 22.658 17.2206 22.9393 16.9393C23.2206 16.658 23.6022 16.5 24 16.5ZM24 33C24.3978 33 24.7794 32.842 25.0607 32.5607C25.342 32.2794 25.5 31.8978 25.5 31.5C25.5 31.1022 25.342 30.7206 25.0607 30.4393C24.7794 30.158 24.3978 30 24 30C23.6022 30 23.2206 30.158 22.9393 30.4393C22.658 30.7206 22.5 31.1022 22.5 31.5C22.5 31.8978 22.658 32.2794 22.9393 32.5607C23.2206 32.842 23.6022 33 24 33Z" fill="var(--color-accent)"/>
</svg>`,
  'search-mark': `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
<path d="M16.5 21.75C16.5 21.0606 16.6358 20.3779 16.8996 19.7409C17.1635 19.104 17.5502 18.5252 18.0377 18.0377C18.5252 17.5502 19.104 17.1635 19.7409 16.8996C20.3779 16.6358 21.0606 16.5 21.75 16.5C22.4394 16.5 23.1221 16.6358 23.7591 16.8996C24.396 17.1635 24.9748 17.5502 25.4623 18.0377C25.9498 18.5252 26.3365 19.104 26.6004 19.7409C26.8642 20.3779 27 21.0606 27 21.75C27 23.1424 26.4469 24.4777 25.4623 25.4623C24.4777 26.4469 23.1424 27 21.75 27C20.3576 27 19.0223 26.4469 18.0377 25.4623C17.0531 24.4777 16.5 23.1424 16.5 21.75Z" fill="var(--color-accent)"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M24 4.5C13.23 4.5 4.5 13.23 4.5 24C4.5 34.77 13.23 43.5 24 43.5C34.77 43.5 43.5 34.77 43.5 24C43.5 13.23 34.77 4.5 24 4.5ZM21.75 13.5C20.4572 13.5003 19.1825 13.8043 18.0288 14.3877C16.8751 14.9711 15.8746 15.8175 15.1081 16.8585C14.3416 17.8996 13.8305 19.1063 13.616 20.3812C13.4015 21.6561 13.4896 22.9635 13.8732 24.1981C14.2569 25.4327 14.9253 26.5599 15.8246 27.4887C16.7238 28.4175 17.8288 29.1219 19.0504 29.5452C20.2719 29.9685 21.5759 30.0988 22.857 29.9256C24.1382 29.7524 25.3607 29.2805 26.426 28.548L30.44 32.56C30.5773 32.7074 30.7429 32.8256 30.9269 32.9076C31.1109 32.9895 31.3095 33.0336 31.511 33.0372C31.7124 33.0407 31.9124 33.0037 32.0992 32.9282C32.286 32.8528 32.4556 32.7405 32.5981 32.5981C32.7405 32.4556 32.8528 32.286 32.9282 32.0992C33.0037 31.9124 33.0407 31.7124 33.0372 31.511C33.0336 31.3095 32.9895 31.1109 32.9076 30.9269C32.8256 30.7429 32.7074 30.5773 32.56 30.44L28.548 26.426C29.4002 25.1873 29.8977 23.7392 29.9867 22.2383C30.0756 20.7373 29.7528 19.2406 29.0529 17.9099C28.353 16.5791 27.3028 15.4649 26.0157 14.6877C24.7286 13.9105 23.2536 13.4998 21.75 13.5Z" fill="var(--color-accent)"/>
</svg>`,
  'info-mark': `<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 24C4.5 13.23 13.23 4.5 24 4.5C34.77 4.5 43.5 13.23 43.5 24C43.5 34.77 34.77 43.5 24 43.5C13.23 43.5 4.5 34.77 4.5 24ZM21.912 21.116C24.204 19.97 26.786 22.042 26.164 24.528L24.746 30.2L24.83 30.16C25.1824 30.0051 25.5809 29.9916 25.9431 30.1223C26.3052 30.253 26.6031 30.518 26.7753 30.8623C26.9475 31.2067 26.9807 31.604 26.868 31.9722C26.7553 32.3403 26.5054 32.651 26.17 32.84L26.09 32.884C23.796 34.03 21.214 31.958 21.836 29.472L23.256 23.8L23.172 23.84C22.9951 23.9383 22.8001 23.9998 22.5988 24.0208C22.3974 24.0418 22.1939 24.0218 22.0006 23.962C21.8072 23.9023 21.6279 23.804 21.4735 23.6731C21.319 23.5423 21.1927 23.3815 21.1021 23.2005C21.0115 23.0195 20.9584 22.822 20.9461 22.62C20.9338 22.418 20.9625 22.2155 21.0305 22.0249C21.0985 21.8342 21.2044 21.6593 21.3418 21.5107C21.4792 21.3621 21.6453 21.2428 21.83 21.16L21.912 21.116ZM24 18C24.3978 18 24.7794 17.842 25.0607 17.5607C25.342 17.2794 25.5 16.8978 25.5 16.5C25.5 16.1022 25.342 15.7206 25.0607 15.4393C24.7794 15.158 24.3978 15 24 15C23.6022 15 23.2206 15.158 22.9393 15.4393C22.658 15.7206 22.5 16.1022 22.5 16.5C22.5 16.8978 22.658 17.2794 22.9393 17.5607C23.2206 17.842 23.6022 18 24 18Z" fill="var(--color-accent)"/>
</svg>`
};

const ICON_TYPES = Object.keys(ICON_SVGS);

/**
 * Process icon blocks and grid layouts inside a container.
 *
 * @param {Element}  container
 * @param {Map}      footnotesMap
 * @param {Function} recurse  - processAllSnippets(container, footnotesMap), passed to avoid circular import
 */
export function processSnippetBlock(container, footnotesMap, recurse) {
  _processIconBlocks(container, footnotesMap, recurse);
  _processGridBlocks(container, footnotesMap, recurse);
  _processGridWithCaptionBlocks(container, footnotesMap, recurse);
}

// ─── Icon blocks ──────────────────────────────────────────────────────────────

function _processIconBlocks(container, footnotesMap, recurse) {
  const allElements = Array.from(container.children);
  const iconPattern = ICON_TYPES.join('|');
  const startRegex  = new RegExp(`\\{\\{(${iconPattern})\\}\\}`);

  for (let i = 0; i < allElements.length; i++) {
    const element = allElements[i];
    const iconMatch = (element.textContent || '').match(startRegex);
    if (!iconMatch) continue;

    const type = iconMatch[1];
    const endRegex = new RegExp(`\\{\\{/${type}\\}\\}`);
    let endIndex = -1, endElement = null;

    for (let j = i; j < allElements.length; j++) {
      if ((allElements[j].textContent || '').match(endRegex)) {
        endIndex = j; endElement = allElements[j]; break;
      }
    }

    if (endIndex === -1) {
      console.warn(`[Content Snippets] {{${type}}} has no closing {{/${type}}}.`);
      continue;
    }

    const contentWrapper = document.createElement('div');
    const contentElements = _collectContent(
      element, allElements, i, endIndex, endElement,
      new RegExp(`\\{\\{${type}\\}\\}\\s*(.+)`, 's'),
      new RegExp(`(.+?)\\s*\\{\\{/${type}\\}\\}`, 's')
    );
    contentElements.forEach(el => contentWrapper.appendChild(el));

    const iconWrapper = document.createElement('div');
    iconWrapper.innerHTML = ICON_SVGS[type];
    iconWrapper.style.width = '4.8rem';
    iconWrapper.style.height = '4.8rem';

    const gridDiv = document.createElement('div');
    gridDiv.className = 'content-grid content-grid--icon';
    gridDiv.appendChild(iconWrapper);
    gridDiv.appendChild(contentWrapper);

    element.replaceWith(gridDiv);
    for (let k = i + 1; k <= endIndex; k++) {
      const el = allElements[k];
      if (el && el.parentNode === container) container.removeChild(el);
    }

    if (recurse) recurse(contentWrapper, footnotesMap);
    else if (footnotesMap) processTooltipReferences(contentWrapper, footnotesMap);

    i = endIndex;
  }
}

// ─── Grid blocks ──────────────────────────────────────────────────────────────

function _processGridBlocks(container, footnotesMap, recurse) {
  const allElements = Array.from(container.children);
  const startRegex  = /\{\{grid:\s*([^}]+)\}\}/;
  const endRegex    = /\{\{\/grid\}\}/;

  for (let i = 0; i < allElements.length; i++) {
    const element = allElements[i];
    const gridMatch = (element.textContent || '').match(startRegex);
    if (!gridMatch) continue;

    const gridValue = gridMatch[1].trim();
    let endIndex = -1, endElement = null;

    for (let j = i; j < allElements.length; j++) {
      if ((allElements[j].textContent || '').match(endRegex)) {
        endIndex = j; endElement = allElements[j]; break;
      }
    }

    if (endIndex === -1) {
      console.warn('[Content Snippets] {{grid}} has no closing {{/grid}}.');
      continue;
    }

    const gridDiv = document.createElement('div');
    gridDiv.className = 'content-grid';

    if (gridValue === '2') gridDiv.classList.add('col-2');
    else if (gridValue === '3') gridDiv.classList.add('col-3');
    else gridDiv.style.gridTemplateColumns = gridValue;

    const contentElements = _collectContent(
      element, allElements, i, endIndex, endElement,
      /\{\{grid:\s*[^}]+\}\}\s*(.+)/s,
      /(.+?)\s*\{\{\/grid\}\}/s
    );
    contentElements.forEach(el => {
      // Skip empty <p> tags Ghost inserts as spacers between blocks
      if (el.tagName === 'P' && el.textContent.trim() === '') return;
      gridDiv.appendChild(el);
    });

    element.replaceWith(gridDiv);
    for (let k = i + 1; k <= endIndex; k++) {
      const el = allElements[k];
      if (el && el.parentNode === container) container.removeChild(el);
    }

    if (recurse) recurse(gridDiv, footnotesMap);
    else if (footnotesMap) processTooltipReferences(gridDiv, footnotesMap);

    i = endIndex;
  }
}

// ─── Grid with caption blocks ─────────────────────────────────────────────────

function _processGridWithCaptionBlocks(container, footnotesMap, recurse) {
  const allElements = Array.from(container.children);
  const startRegex  = /\{\{grid-with-caption:\s*([^}]+)\}\}/;
  const endRegex    = /\{\{\/grid-with-caption\}\}/;

  for (let i = 0; i < allElements.length; i++) {
    const element = allElements[i];
    const gridMatch = (element.textContent || '').match(startRegex);
    if (!gridMatch) continue;

    const gridValue = gridMatch[1].trim();
    let endIndex = -1, endElement = null;

    for (let j = i; j < allElements.length; j++) {
      if ((allElements[j].textContent || '').match(endRegex)) {
        endIndex = j; endElement = allElements[j]; break;
      }
    }

    if (endIndex === -1) {
      console.warn('[Content Snippets] {{grid-with-caption}} has no closing {{/grid-with-caption}}.');
      continue;
    }

    const contentElements = _collectContent(
      element, allElements, i, endIndex, endElement,
      /\{\{grid-with-caption:\s*[^}]+\}\}\s*(.+)/s,
      /(.+?)\s*\{\{\/grid-with-caption\}\}/s
    ).filter(el => !(el.tagName === 'P' && el.textContent.trim() === ''));

    // Last <p> becomes the caption; everything else goes into the grid
    const lastP = [...contentElements].reverse().find(el => el.tagName === 'P');
    const gridElements = lastP
      ? contentElements.filter(el => el !== lastP)
      : contentElements;

    const gridDiv = document.createElement('div');
    gridDiv.className = 'content-grid';
    if (gridValue === '2') gridDiv.classList.add('col-2');
    else if (gridValue === '3') gridDiv.classList.add('col-3');
    else gridDiv.style.gridTemplateColumns = gridValue;
    gridElements.forEach(el => gridDiv.appendChild(el));

    const wrapper = document.createElement('div');
    wrapper.className = 'content-grid-with-caption';
    wrapper.appendChild(gridDiv);

    if (lastP) {
      lastP.className = (lastP.className ? lastP.className + ' ' : '') + 'content-grid-caption';
      wrapper.appendChild(lastP);
    }

    element.replaceWith(wrapper);
    for (let k = i + 1; k <= endIndex; k++) {
      const el = allElements[k];
      if (el && el.parentNode === container) container.removeChild(el);
    }

    if (recurse) recurse(gridDiv, footnotesMap);
    else if (footnotesMap) processTooltipReferences(gridDiv, footnotesMap);

    i = endIndex;
  }
}

// ─── Shared helper ────────────────────────────────────────────────────────────

function _collectContent(startEl, allElements, startIdx, endIdx, endEl, startCapture, endCapture) {
  const result = [];

  // Opening and closing markers both live in the same element (e.g. a single
  // short `<p>{{marker}}...{{/marker}}</p>`) — apply endCapture to the result
  // of startCapture instead of re-matching the full innerHTML twice, otherwise
  // the "after open" and "before close" captures overlap and the content
  // (plus a leftover literal marker) gets added twice.
  if (startEl === endEl) {
    const html = startEl.innerHTML || '';
    const startMatch = html.match(startCapture);
    const afterOpen = startMatch?.[1] ?? '';
    const closeMatch = afterOpen.match(endCapture);
    const middle = (closeMatch?.[1] ?? afterOpen).trim();
    if (middle) {
      const tmp = document.createElement('div');
      tmp.innerHTML = middle;
      while (tmp.firstChild) result.push(tmp.removeChild(tmp.firstChild));
    }
    return result;
  }

  // Content after the opening marker (same element)
  const startHTML = startEl.innerHTML || '';
  const startMatch = startHTML.match(startCapture);
  if (startMatch?.[1]?.trim()) {
    const tmp = document.createElement('div');
    tmp.innerHTML = startMatch[1].trim();
    while (tmp.firstChild) result.push(tmp.removeChild(tmp.firstChild));
  }

  // Middle elements — move nodes directly (not cloneNode) to preserve event listeners
  for (let k = startIdx + 1; k < endIdx; k++) {
    if (allElements[k]?.parentNode) result.push(allElements[k]);
  }

  // Content before the closing marker (same element as end)
  const endHTML = endEl.innerHTML || '';
  const endMatch = endHTML.match(endCapture);
  if (endMatch?.[1]?.trim()) {
    const tmp = document.createElement('div');
    tmp.innerHTML = endMatch[1].trim();
    while (tmp.firstChild) result.push(tmp.removeChild(tmp.firstChild));
  }

  return result;
}
